import React from "react";

export const getChildrenByName = (children: React.ReactNode, displayName: string) => {
  if (!children) return null;

  // @ts-ignore
  const components = React.Children.map(children, child => (child?.type?.displayName === displayName ? child : null));
  return (components || []).length > 0 ? components : null;
};
